import { LogItem } from "@lhd/types";

const normalizeNoteToken = (s: string) => s.replace(/\r\n/g, "\n").trim();

export function dayMemoFromApiLogtimes(
  logtimes: LogItem[] | undefined,
): string {
  const list = logtimes ?? [];
  if (list.length === 0) return "";

  const noteLog = list.find((lt) => lt.log_type === "note");
  if (noteLog?.note != null) {
    const normalized = normalizeNoteToken(String(noteLog.note));
    if (normalized) return normalized;
  }

  const firstWithNote = list.find((lt) => {
    if (lt.note == null) return false;
    return normalizeNoteToken(String(lt.note)) !== "";
  });
  if (!firstWithNote?.note) return "";

  return normalizeNoteToken(String(firstWithNote.note));
}
